export function composeLinkedinUrl(url: string) {
  return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`;
}
export function composeXUrl(url: string) {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
}